import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { GridColDef } from '@mui/x-data-grid-pro';

export const useGetColumnDefs = (): GridColDef[] => {
  const { t } = useTranslation('common', { keyPrefix: 'employers' });

  return useMemo(
    () => [
      {
        field: 'name',
        type: 'string',
        headerName: t('grid.name'),
        hideable: false,
        minWidth: 100,
        flex: 1
      },
      {
        field: 'nameBrief',
        type: 'string',
        headerName: t('grid.nameBrief'),
        width: 100,
        flex: 1
      }
    ],
    [t]
  );
};
